import React, { Fragment, useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ErrorToaster, SuccessToaster } from 'app/components/Toaster/Toaster'
import CompaniesServices from 'app/apis/Companies/CompaniesServices'
import colors from 'app/styles/colors'
import Layout from 'app/layout/Layout'
import BreadCrumbs from 'app/components/Breadcrumbs/Breadcrumbs'
import CompanyForm from 'app/components/Forms/CompanyForm'

function ViewCompany() {

  const navigate = useNavigate()

  // *For Loading
  const [loading, setLoading] = useState(false)

  // *For Update Company
  const updateCompany = async (obj) => {
    setLoading(true)
    try {
      const { status, responseCode, message } = await CompaniesServices.updatedCompanyDetail(obj)
      if (status === true && responseCode === 200) {
        SuccessToaster(message)
        navigate("/companies")
      }
    } catch (error) {
      console.log('file: ViewCompany.js:28 => updateCompany => error', error)
      ErrorToaster(error)
    }
    finally {
      setLoading(false)
    }
  }

  return (
    <Fragment>

      <Box sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px", }}>

        <Grid container alignItems="center" justifyContent="space-between" sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}>
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Company Information
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <BreadCrumbs currentPage={['Company Information']} />
          </Grid>
        </Grid>

        <CompanyForm loading={loading} onSubmit={updateCompany} />

      </Box>
    </Fragment>
  )
}

export default ViewCompany